import { api } from '../lib/axios';
import { ListingInterface } from './types/ListingsServiceType';

export function getListing(): Promise<ListingInterface> {
  return api.get('anuncio', {
    params: {
      page: 0,
      size: 200
    }
  });
}
